import { MailingBriefSortedWorksheetFormModel } from '../mailing-brief/sorted/mailingBriefSortedWorksheetFormModel';

type FormDefaultValues = Partial<MailingBriefSortedWorksheetFormModel>;

export const sortedWorksheetDefaults: FormDefaultValues = {
  printingType: 'OnepostPrint',
  labelDeliveryService: 'Anytime',
};
